// extracted by mini-css-extract-plugin
export var copyableField = "_hg-4";
export var customerBadge = "_hg-0";
export var customerInfoTitle = "_hg-2";
export var details = "_hg-1";
export var dropdownContainer = "_hg-5";
export var dropdownImage = "_hg-6";
export var editAssigneeForm = "_hg-a";
export var editButton = "_hg-3";
export var email = "_hg-7";
export var hidden = "_hg-d";
export var input = "_hg-8";
export var saveButton = "_hg-b";
export var shopifyIcon = "_hg-c";
export var username = "_hg-9";